import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucChucDanh } from 'src/app/shared/DanhMucChucDanh.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class KienThucATTPTapTinDinhKemService extends BaseService{

    DisplayColumns001: string[] = ['FileName', 'Name', 'Save'];

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "KienThucATTPTapTinDinhKem";
    }
}

